import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setStatusFilter } from '../redux/actions';
import { statusFilters } from '../redux/constants';

function FilterButtons() {
  const dispatch = useDispatch();
  const current = useSelector((state) => state.filters.status);

  return (
    <div >
      {Object.values(statusFilters).map((f) => (
        <button
          key={f}
          onClick={() => dispatch(setStatusFilter(f))}
          disabled={current === f}
       
        >
          {f}
        </button>
      ))}
    </div>
  );
}

export default FilterButtons;
